import type { TelefoneBloqueadosModel } from "../models/telefonesBloqueadosModel"
import {
    TelefoneBloqueadosActionsTypes,
    type TelefoneBloqueadosActions,
} from "./telefonesBloqueadosActions"

export function telefonesBloqueadosReducer(
    state: TelefoneBloqueadosModel,
    action: TelefoneBloqueadosActions
): TelefoneBloqueadosModel {
    switch (action.type) {
        case TelefoneBloqueadosActionsTypes.CARREGAR:
            return { ...state, lista: action.payload }
        default:
            return state
    }
}
